import type { PropsWithChildren } from 'react'
import { Grid, type GridProps } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  (theme) => ({
    container: {
      backgroundColor: theme.colors.contentBackground,
      padding: theme.spacing(3),
    },
  }),
  { name: 'MigrationStep' },
)

const MigrationStep = ({
  children,
  ...props
}: PropsWithChildren<GridProps>) => {
  const classes = useStyles()

  return (
    <Grid container className={classes.container} width={900} {...props}>
      {children}
    </Grid>
  )
}

export default MigrationStep
